import {DI, observable} from '@genesislcap/web-core';

export enum AppMode {
  Landing = 'Landing',
  PBI = 'PBI',
  MBM = 'MBM',
  UserManagement = 'UserManagement',
}

export interface ModeService {
  setMode: (mode: AppMode | undefined) => void,
  getMode: () => AppMode
}

export class DefaultModeService implements ModeService {
  @observable mode: AppMode | undefined;

  constructor() {
    const mode = sessionStorage.getItem('mode');
    if (mode) {
      this.mode = mode as AppMode;
    }
  }

  setMode(mode: AppMode | undefined) {
    sessionStorage.setItem('mode', mode);
    this.mode = mode;
  }

  getMode(): AppMode | undefined {
    return this.mode;
  }
}

export const ModeService = DI.createInterface<ModeService>((x) => x.singleton(DefaultModeService));
